export default [




  { title: 'Fees', routeName: 'statistics-fees' },

  { title: 'Trades', routeName: 'statistics-trades' },




  { title: 'Requisites', routeName: 'statistics-requisites' },

  { title: 'Merchants', routeName: 'statistics-merchants' },

  { title: 'Traders', routeName: 'statistics-traders' },

  { title: 'Referrals', routeName: 'statistics-referrals' },

  { title: 'Transactions', routeName: 'statistics-transactions' },
];
